import { render, staticRenderFns } from "./Invalidations.vue?vue&type=template&id=0fd336ae&scoped=true&"
import script from "./Invalidations.vue?vue&type=script&lang=js&"
export * from "./Invalidations.vue?vue&type=script&lang=js&"
import style0 from "./Invalidations.vue?vue&type=style&index=0&id=0fd336ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd336ae",
  null
  
)

export default component.exports